/**
 * P5-03: FooterBar —— 底部链接与 #toggleCenter React 化。
 *
 * 旧结构：
 * - #toggleCenter：位于 #game 右侧，点击切换页面居中/靠左。
 * - #footerLinks：位于 #gamePageContainer 右下角的外部链接。
 *
 * 本组件根据 mode prop 渲染其中一块，由 index.html 分别挂载到对应锚点。
 * toggleCenter 点击时同步 engine 的 isCenter、调用 updateCenter() 并保存 UI 设置。
 */
import { useCallback, useState } from "react";
import { getGame } from "../../bridge/GameBridge";

interface FooterBarProps {
  mode?: "toggle" | "links";
}

function ToggleCenter() {
  const ui = getGame()?.ui;
  const [isCenter, setIsCenter] = useState(
    !!ui && typeof ui.isCenter === "boolean" ? ui.isCenter : false,
  );

  const handleToggle = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    const game = getGame();
    const ui = game?.ui;
    if (!ui) {
      return;
    }
    const next = !isCenter;
    ui.isCenter = next;
    setIsCenter(next);
    if (typeof ui.updateCenter === "function") {
      ui.updateCenter();
    }
    if (typeof ui.save === "function") {
      ui.save();
    }
  }, [isCenter]);

  return (
    <div
      id="toggleCenter"
      onClick={handleToggle}
      className="column"
      title="Toggle centered view"
      role="button"
      tabIndex={0}
    >
      <span className="toggleCenter">
        <div
          id="toggleCenterIcon"
          className={`svg-icon ${isCenter ? "left" : "right"}`}
        />
      </span>
    </div>
  );
}

function FooterLinks() {
  const handleCredits = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    window.KGNewUI?.dialogs?.showCredits?.();
  }, []);

  return (
    <div id="footerLinks" className="links-block">
      <a id="wiki" href="https://wiki.kittensgame.com/" target="_blank" rel="noreferrer">
        wiki
      </a>{" "}
      |{" "}
      <a id="discord" href="https://discord.gg/2arBf9K" target="_blank" rel="noreferrer">
        Discord
      </a>{" "}
      |{" "}
      <a id="credits" href="#" onClick={handleCredits}>
        credits
      </a>{" "}
      |{" "}
      <a
        id="patreon"
        href="https://www.patreon.com/bloodrizer"
        target="_blank"
        rel="noreferrer"
      >
        Patreon
      </a>
    </div>
  );
}

export default function FooterBar({ mode = "links" }: FooterBarProps) {
  if (mode === "toggle") {
    return <ToggleCenter />;
  }
  return <FooterLinks />;
}
